import { SvelteFacet } from "./SvelteFacet";
import { addFilterButtonTeaser } from "./FilterButton";
import { events } from "../events";

export function registerBlackFridayHandlers() {
  events.onFilterSectionLoaded(blackFridayFlagTeaser);
}

function blackFridayFlagTeaser() {
  const blackFridayFacet: SvelteFacet | undefined = SvelteFacet.facetName("black-friday");

  if (blackFridayFacet && !blackFridayFacet.facet.hidden) {
    addFilterButtonTeaser("black-friday");
  }
}
